import React, { FC } from 'react'
import styled from 'styled-components'
import { Icon } from '@iconify/react'
import cn from 'classnames'

const StyledCheckbox = styled.div`
  width: fit-content;
  &.controlled {
    cursor: pointer;
  }
`

interface CheckboxProps extends React.HTMLAttributes<HTMLDivElement> {
  checked?: boolean
  onToggle?: (checked?: boolean) => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const Checkbox: FC<CheckboxProps> = ({ checked = false, onToggle, onChange, ...rest }) => {
  const handleClick = () => {
    const newValue = !Boolean(checked)

    if (onToggle) onToggle(newValue)

    if (onChange) {
      onChange({
        target: { checked: newValue },
      } as React.ChangeEvent<HTMLInputElement>)
    }
  }

  return (
    <StyledCheckbox
      onClick={handleClick}
      className={cn({ controlled: Boolean(onToggle || onChange) })}
      {...rest}
    >
      {checked ? (
        <Icon icon="uil:check-square" width={24} color="#499976" />
      ) : (
        <Icon icon="uil:square" width={24} color="#8d8d8d" />
      )}
    </StyledCheckbox>
  )
}

export { Checkbox }
